export enum ROUTE_NAMES {
  // VIEWS
  HOME = 'home',
  REFUELINGS = 'refuelings',
  DASHBOARD = 'dashboard',
  ABOUT = 'about',

  // OTHER
  ERROR = 'error',

  // AUTHENTICATION RELATED
  CALLBACK = 'callback',
}
